import { getVersionForClone } from '@/utils'

import { BaseInput, baseInputCls } from './BaseInput'
import { Clone1Input, clone1InputCls } from './Clone1Input'

export * from './BaseInput'

export const inputCls = getVersionForClone({
	base: baseInputCls,
	clone1: clone1InputCls,
})

export const Input = getVersionForClone({
	base: BaseInput,
	clone1: Clone1Input,
})
